import { apiGet } from './index'

// 我的点赞
const myLike = params =>
  apiGet(`/api/area/like/myListPage/${params.id}`, params)
// 点赞我的
const likeMe = params =>
  apiGet(`/api/area/like/myPasvListPage/${params.id}`, params)
// 我的评论
const myComment = params =>
  apiGet(`/api/area/comment/myListPage/${params.id}`, params)
// 评论我的
const commentMy = params =>
  apiGet(`/api/area/comment/myPasvListPage/${params.id}`, params)
// 我的点赞
const myLikeDoc = params =>
  apiGet(`/api/userCourseLog/getDocuLikeList`, params)
// 我的点赞
const myLikeCase = params =>
  apiGet(`/api/userCourseLog/caseLike`, params)
// 点赞我的
const likeMeCase = params =>
  apiGet(`/api/userCourseLog/caseLikeMine`, params)
export { myLike, likeMe, myComment, commentMy, myLikeDoc, myLikeCase, likeMeCase }



// WEBPACK FOOTER //
// ./src/api/like_comment.js